<template>
  <form class="py-12" v-on:submit.prevent="prevent">
    <v-slide-x-transition>
      <v-card class="mx-auto my-3" max-width="600" :loading="loading">
        <v-card-title> {{ $t('auth.password.reset.resetPassTitle') }}</v-card-title>
        <v-card-text>
          <div class="text-h6" v-if="user && user.name">{{ user.name }}</div>
          <v-text-field
            v-model="password"
            :error-messages="passwordErrors"
            :label="$t('auth.password.reset.password')"
            required
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            @input="v$.password.$touch()"
            @blur="v$.password.$touch()"
            @keyup.enter="$refs.confirm.$el.focus()"
          ></v-text-field>

          <v-text-field
            ref="confirm"
            v-model="confirm"
            :error-messages="confirmErrors"
            :label="$t('auth.password.reset.confirmPass')"
            required
            :type="showPasswordConfirm ? 'text' : 'password'"
            :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPasswordConfirm = !showPasswordConfirm"
            @input="v$.confirm.$touch()"
            @blur="v$.confirm.$touch()"
            @keyup.enter="submit"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="d-flex justify-end">
          <div class="d-flex justify-end align-center" style="width: 100%">
            <v-btn
              class="mr-2"
              color="primary"
              elevation="0"
              type="button"
              :loading="processing"
              :disabled="v$.$invalid && v$.$dirty || disabledBtn == true"
              @click="submit()"
            >
           {{$t('auth.password.reset.reset')}}
            </v-btn>
          </div>
        </v-card-actions>
       
        <!-- <v-card-actions class="pb-3">
          <div>
            <a
              href="javascript:void(0)"
              class="ma-3 d-block"
              @click="$emit('setPage', 'user')"
            >
            {{$t('auth.password.reset.signDiferentAccount')}}
            </a>
            <a
              href="javascript:void(0)"
              class="ma-3 d-block"
              @click="$emit('setPage', 'password')"
            >
            {{$t('auth.password.reset.cancelPassChante')}}
            </a>
          </div>
        </v-card-actions> -->
      </v-card>
    </v-slide-x-transition>
  </form>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs } from "@vuelidate/validators";
import { mapGetters, mapActions, mapState } from "vuex";
import axios from 'axios'
export default {
  setup() {
    return { v$: useVuelidate() };
  },

  data: () => ({
    disabledBtn: false,
    showPassword: false,
    showPasswordConfirm: false,
    processing: false,
    loading: false,
    password: "",
    confirm: "",
  }),

  validations() {
    return {
      password: { required, minLength: minLength(6) },
      confirm: { required, sameAs: sameAs(this.password) },
    };
  },
  props: {
    user: Object,
  },

  computed: {
    passwordErrors() {
      const errors = [];
      if (!this.v$.password.$dirty) return errors;
      this.v$.password.minLength.$invalid &&
        errors.push(this.$t('auth.password.password.errors.required',{count:6}));
      this.v$.password.required.$invalid && errors.push(this.$t('auth.password.password.errors.required'));
      return errors;
    },
    confirmErrors() {
      const errors = [];
      if (!this.v$.confirm.$dirty) return errors;
      this.v$.confirm.sameAs.$invalid && errors.push(this.$t('auth.password.password.errors.sameAs'));
      this.v$.confirm.required.$invalid &&
        errors.push(this.$t('auth.password.password.errors.sameAss'));
      return errors;
    },
  },

  methods: {
    ...mapActions("snackbar", ["showSnack"]),
    prevent(event) {
      event.stopPropagation();
    },
    submit() {
      this.processing = true;
      this.v$.$touch();
      if (this.user.email && !this.v$.$invalid) {
        const Form = {
          token: this.user.token,
          password: this.password,
          passwordConfirm: this.confirm,
        };
        axios.create({
          headers: {
            "Content-Type": "application/json",
          },
        });
        axios
          .post(`${this.$apiURL}users/password/reset`, Form)
          .then((response) => {
            this.disabledBtn = true
            console.log("response", response);
            this.showSnack({
              text: this.$t("auth.password.reset.snackSucess"),
              color: "success",
              timeout: 2000,
              icon: "mdi-check",
            });
            setTimeout(() => {
              this.$emit('setPage','password')
            }, 2500);
          })
          .catch((response) => {
           console.log(response)
           if(response?.response?.data?.errors[0][0] == 'errors.password.youCannotUsePreviousPassword'){
            this.showSnack({
              text: this.$t("accountSettings.security.err.diff"),
              color: "error",
              timeout: 4000,
              icon: "mdi-alpha-x-circle-outline",
            });}else{
              this.showSnack({
              text: this.$t("auth.password.reset.snackError"),
              color: "error",
              timeout: 4000,
              icon: "mdi-alpha-x-circle-outline",
            });
            }
          });
        console.log("resetando...");
        this.processing = false;
      } else {
        this.processing = false;
      }
    },
  },
};
</script>
